export default __webpack_public_path__ + "static/media/Immagine_4.08da42b8.jpg";